import { useQuery } from 'react-query'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { errorAlert } from '../../../utils/alert'

type Item = {
  cod: number
  cod_usuario: number
  nome: string
  descricao: null
  token: string
  usuario_nome: string
  executado: boolean
  tipo: number
  tipo_nome: string
  cod_aplicativo: number
  log: null
}

type ItemUser = {
  cod: number
  nome:string
  email: string
}

interface CadastroCargos {
  itens: Item[]
  total: number
}

interface UsuarioAtivos {
  itens: ItemUser[]
}

export const useGetComandos = (pagination = 15, page = 1, nome?: string) => {
  const queryKey: any = [`/adm/comando-app`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    CadastroCargos,
    Error
  >(
    queryKey,
    async () => {
      const paramNome = nome ? `&nome=${nome}` : ''
      return api
        .get(
          `/adm/comando-app?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }&pagination=${pagination}&page=${page}${paramNome}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de comandos!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_comandos: data,
    carregando_comandos: isFetching,
    refetch_data_comandos: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

export const useGetEditarComandos = (cod: number) => {
  const queryKey: any = [`/adm/comando-app_${cod}`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    CadastroCargos,
    Error
  >(
    queryKey,
    async () => {
      return api
        .get(
          `/adm/comando-app?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }&pagination=-1&cod=${cod}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de comandos!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_comandos_editar: data,
    carregando_comandos_editar: isFetching,
    refetch_data_comandos_editar: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

export const useGetEquipeAtivo = () => {
  const queryKey: any = [`/usuarios-ativos-equipe`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    UsuarioAtivos,
    Error
  >(
    queryKey,
    async () => {
      return api
        .get(
          `usuarios-ativos-equipe?
          }&pagination=-1`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de comandos!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_usuarios_ativos: data,
    carregando_usuarios_ativos: isFetching,
    refetch_data_usuarios_ativos: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}